import logo from './logo.svg';
import './App.css';
import Counter from "./Component/Counter"

function App() {
  return (
    <div className="App">
    <Counter/>
    </div>
  );
}

export default App;
